// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editing-heading{font-weight:700;color:#0ea5bf}.part.part-2,.part.part-3{padding:30px 30px 10px!important}@media screen and (max-width:575px){.part.part-1,.part.part-2,.part.part-3{padding:30px 15px 10px!important}}.edu-err{color:red}", ""]);
// Exports
module.exports = exports;
